<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:3pc"></p>
<p class="copyrightpagepara">Copyright © 2012 by Maureen Caudill</p>
<p class="copyrightpagepara">All rights reserved. No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from Hampton Roads Publishing, Inc. Reviewers may quote brief passages.</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">Cover design by Jim Warner</p>
<p class="copyrightpagepara">Interior designed by Maureen Forys, Happenstance Type-O-Rama</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">Hampton Roads Publishing Company, Inc.</p>
<p class="copyrightpagepara">Charlottesville, VA 22906</p>
<p class="copyrightpagepara">Distributed by Red Wheel/Weiser, <span class="small">LLC</span></p>
<p class="copyrightpagepara"><a href="http://www.redwheelweiser.com" target="_blank"><i>www.redwheelweiser.com</i></a></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">Sign up for our newsletter and special offers by going to</p>
<p class="copyrightpagepara"><a href="http://www.redwheelweiser.com/newsletter/" target="_blank"><i>www.redwheelweiser.com/newsletter/</i></a>.</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">ISBN: 978-1-57174-663-4</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">Library of Congress Cataloging-in-Publication Data available upon request</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">Printed on acid-free paper in the United States of America</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">MAL</p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="copyrightpagepara">10 9 8 7 6 5 4 3 2 1</p>
<p style="text-align:center; margin-top:1pc"></p>
<p class="copyrightpagepara"><a href="http://www.redwheelweiser.com" target="_blank">www.redwheelweiser.com</a></p>
<p class="copyrightpagepara"><a href="http://www.redwheelweiser.com/newsletter" target="_blank">www.redwheelweiser.com/newsletter</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02copyright.vue?d575dcf2